import CompanyLogo from "assets/images/companyLogo.png";
import favicon from "assets/images/favicon.ico";

export const companyDetails = {
    companyName: "ITER-B2C",
    companyLogo: CompanyLogo,
    favicon: favicon
}